export default "__VITE_ASSET__Dmvj2tV7__"